import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  languageId: [],
};

const languageSlice = createSlice({
  name: "languageId",
  initialState: initialState,
  reducers: {
    setLanguageId: (state, action) => {
      state.languageId = action.payload;
    },
  },
});

export const { setLanguageId } = languageSlice.actions;
export default languageSlice.reducer;
